export default {
	module: 'linkBuilder',
	actions: {
		create: true,
	}
}
